import {Injectable} from "@angular/core";
import {DokumentId, DokumentVersjonModell, PotensiellDokumentSignatarModell, ProtokollRessursClient, TynnMøteModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {FavorittDatatjeneste} from "felles-ng2/tjenester/datalager/FavorittDatatjeneste";
import {DokumentSigneringDatatjeneste} from "felles-ng2/tjenester/datalager/DokumentSigneringDatatjeneste";
import {Observable} from "rxjs";
import {i18n} from "felles-ng2/tjenester/i18n/Oversettelser";

@Injectable()
export class DokumentvisningKomponentAvhengigheter {

    constructor(private dokumentSigneringDatatjeneste: DokumentSigneringDatatjeneste,
                private favorittDatatjeneste: FavorittDatatjeneste,
                private protokollRessurs: ProtokollRessursClient) {
    }

    finnMøteProtokolldokumentISakErProtokollFor(dokumentId: DokumentId): Promise<TynnMøteModell> {
        return this.protokollRessurs.finnMøtemodellProtokolldokumentISakGjelderFor(dokumentId)
          .somPromiseVisStandardMeldingVedFeil(i18n('Kunne ikke laste protokollinformasjon'))
    }

    signatarinformasjonForAktivBruker(dokumentId: DokumentId): Observable<PotensiellDokumentSignatarModell> {
        return this.dokumentSigneringDatatjeneste.signatarinformasjonForAktivBruker(dokumentId);
    }

    erFavoritt(dokumentversjon: DokumentVersjonModell): boolean {
        return this.favorittDatatjeneste.erFavoritt(dokumentversjon);
    }

}

